import * as forgot from '../actions/forgot-password';

import * as fromForgot from './forgot-password';
import * as fromReset from './password-reset';

import { createFeatureSelector, createSelector } from '@ngrx/store';


export interface ForgotState {
  forgot: fromForgot.State;
  reset: fromReset.State;
}

export const reducers = {
  forgot: fromForgot.reducer,
  reset: fromReset.reducer,
};

export const selectForgotPasswordState = createFeatureSelector<ForgotState>('forgot-password');

export const selectForgotState = createSelector(
  selectForgotPasswordState,
  (state: ForgotState) => state.forgot,
);

export const selectResetState = createSelector(
  selectForgotPasswordState,
  (state: ForgotState) => state.reset,
);


export const getForgotPasswordPageForm = createSelector(
  selectForgotState,
  fromForgot.getForm,
);


export const getForgotPasswordPagePending = createSelector(
  selectForgotState,
  fromForgot.getPending,
);


export const getForgotPasswordPageError = createSelector(
  selectForgotState,
  fromForgot.getError,
);

export const getForgotPasswordPageSuccess = createSelector(
  selectForgotState,
  fromForgot.getSuccess,
);


export const getForgotPasswordPageCode = createSelector(
  selectForgotState,
  fromForgot.getCode,
);

export const getForgotPasswordPageEmailLinkSuccess = createSelector(
  selectForgotState,
  fromForgot.getEmailLinkSuccess,
);




export const getResetPasswordPageForm = createSelector(
  selectResetState,
  fromReset.getForm,
);


export const getResetPasswordPagePending = createSelector(
  selectResetState,
  fromReset.getPending,
);


export const getResetPasswordPageError = createSelector(
  selectResetState,
  fromReset.getError,
);



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/reducers/index.ts